import { palette } from '@livable/saas-react-components';
const MuiModal = {
  styleOverrides: {
    root: {
      overflowY: 'auto',
      overflowX: 'hidden',
      '& .MuiBackdrop-root': {
        backgroundColor: "".concat(palette.shades[800], "cc"),
        '&.MuiBackdrop-invisible': {
          backgroundColor: 'transparent'
        }
      }
    }
  },
  variants: [{
    props: {
      variant: 'wide'
    },
    style: {
      maxWidth: '940px',
      width: '100%'
    }
  }]
};
export default MuiModal;